import React from 'react'
import authRoles from 'auth/authRoles'
import _ from '@lodash'
import { Redirect } from 'react-router-dom'
import { FuseUtils } from '@fuse/index'
import { LoginConfig } from 'main/content/login/LoginConfig'
import { DashboardConfig } from 'main/content/dashboard/DashboardConfig'
import { ContabilitaConfig } from 'main/content/contabilita/ContabilitaConfig'
import { TransazioniConfig } from 'main/content/transazioni/TransazioniConfig'
import { ChiusureConfig } from 'main/content/chiusure/ChiusureConfig'
import { UtentiConfig } from 'main/content/utenti/UtentiConfig'
import { PolizzeConfig } from 'main/content/polizze/PolizzeConfig'
import { AnagraficheConfig } from 'main/content/anagrafiche/AnagraficheConfig'
import { QuotazioniConfig } from 'main/content/quotazioni/QuotazioniConfig'
import { RichiesteConfig } from 'main/content/richieste/RichiesteConfig'
import { LogsConfig } from 'main/content/logs/LogsConfig'
import { StatisticheConfig } from 'main/content/statistiche/StatisticheConfig'
import { TasksConfig } from 'main/content/tasks/TasksConfig'
import { AmministrazioneConfig } from 'main/content/amministrazione/AmministrazioneConfig'
import { FaqsConfig } from 'main/content/faqs/FaqsConfig'
import { UtmConfig } from 'main/content/utm/UtmConfig'
import { CommercialiConfig } from 'main/content/commerciali/CommercialiConfig'
import { CalendarConfig } from 'main/content/calendar/CalendarConfig'
import { DashboardOpsConfig } from 'main/content/dashboardOps/DashboardOpsConfig'
import { StoricoStipendiConfig } from 'main/content/storicoStipendi/StoricoStipendiConfig'
import { CompagnieConfig } from 'main/content/compagnie/CompagnieConfig'
import { AssegnazioneSkillConfig } from 'main/content/assegnazioneSkill/AssegnazioneSkillConfig'
import { ListaDisassegnazioniConfig } from 'main/content/listaDisassegnazioni/ListDisassegnazioniConfig'

const setAdminAuth = (configs) => {
  return configs.map(config => _.merge({}, config, { auth: authRoles.admin }))
}

const routeConfigs = [
  ...setAdminAuth([
    DashboardConfig,
    ContabilitaConfig,
    TransazioniConfig,
    ChiusureConfig,
    UtentiConfig,
    AnagraficheConfig,
    QuotazioniConfig,
    RichiesteConfig,
    LogsConfig,
    StatisticheConfig,
    TasksConfig,
    AmministrazioneConfig,
    FaqsConfig,
    UtmConfig,
    CommercialiConfig,
    CalendarConfig,
    DashboardOpsConfig,
    PolizzeConfig,
    StoricoStipendiConfig,
    ListaDisassegnazioniConfig,
    CompagnieConfig,
    AssegnazioneSkillConfig
  ]),
  LoginConfig
]

export const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/',
    component: () => <Redirect to='/' />
  },
  {
    path: '/login',
    component: () => <Redirect to='/login' />
  },
  {
    path: '/logout',
    component: () => <Redirect to='/logout' />
  },
  {
    path: '/dashboard',
    component: () => <Redirect to='/dashboard' />
  },
  {
    path: '/storico_stipendi',
    component: () => <Redirect to='/storico_stipendi' />
  },
  {
    path: '/contabilita/:contabilita',
    component: () => <Redirect to='/contabilita/:contabilita' />
  },
  {
    path: '/transazioni/:contabilita',
    component: () => <Redirect to='/transazioni/:contabilita' />
  },
  {
    path: '/chiusure',
    component: () => <Redirect to='/chiusure' />
  },
  {
    path: '/utenti',
    component: () => <Redirect to='/utenti' />
  },
  {
    path: '/anagrafiche',
    component: () => <Redirect to='/anagrafiche' />
  },
  {
    path: '/quotazione',
    component: () => <Redirect to='/quotazione' />
  },
  {
    path: '/richiesta',
    component: () => <Redirect to='/richiesta' />
  },
  {
    path: '/in-emissione',
    component: () => <Redirect to='/in-emissione' />
  },
  {
    path: '/statistiche/incassi',
    component: () => <Redirect to='/statistiche/incassi' />
  },
  {
    path: '/statistiche/disassegnate',
    component: () => <Redirect to='/statistiche/disassegnate' />
  },
  {
    path: '/tasks',
    component: () => <Redirect to='/tasks' />
  },
  {
    path: '/logs',
    component: () => <Redirect to='/logs' />
  },
  {
    path: '/faqs',
    component: () => <Redirect to='/faqs' />
  },
  {
    path: '/commerciali',
    component: () => <Redirect to='/commerciali' />
  },
  {
    path: '/utm',
    component: () => <Redirect to='/utm' />
  },
  {
    path: '/amministrazione',
    component: () => <Redirect to='/amministrazione' />
  },
  {
    path: '/calendar',
    component: () => <Redirect to='/calendar' />
  },
  {
    path: '/dashboardOps',
    component: () => <Redirect to='/dashboardOps' />
  },
  {
    path: '/polizze',
    component: () => <Redirect to='/polizze' />
  },
  {
    path: '/stipendi',
    component: () => <Redirect to='/stipendi' />
  },
  {
    path: '/assegnazione_skill',
    component: () => <Redirect to='assegnazione_skill' />
  }
]
